/**
 * 
 * @param {转入数组} arr 
 * @param {属性名称} item 
 * @param {返回名称1返回id2} n 
 * @returns 
 */
export const unit = (arr,compare,n) => {
    if(n === 1) return arr.filter(v => v.value == compare)[0].label;
    if(n === 2) return arr.filter(v => v.value == compare)[0].value;
}

function getTime(time){
    let date = new Date();
    date.setHours(parseInt(time), parseInt(time.split(":")[1])); // 设置小时和分钟
    date.setMinutes(date.getMinutes() + 30); // 增加半小时
    return  time = date.getHours() + ":" + (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
}

/**
 * 
 * @param { 传入数组 时间段和是否选中
 * } arr 
 * @returns 
 */
export function analyzeTime(arr) {
  let results = [];
  let start = "";
  let end = "";

  for (let i = 0; i < arr.length; i++) {
    if (arr[i].istrue) {
      if (start === "") {
        start = arr[i].time;
        end = arr[i].time;
      } else {
        end = arr[i].time;
      }
    } else {
      if (start !== "" && end !== "") {
        // if(start == end){
        //    console.log(end)
        //    console.log(getTime(end))
        //     end = 
        // }
        // console.log(end)
        results.push(start + "-" + (end = getTime(end)));
        start = "";
        end = "";
      }
    }
  }

  if (start !== "" && end !== "") {
    results.push(start + "-" + end);
  }

  return results.join(",");
}

const arr = [
  { time: "00.30", istrue: true },
//   { time: "01.00", istrue: true },
  { time: "01.00", istrue: false },
  { time: "01.30", istrue: false },
  { time: "02.00", istrue: true },
  { time: "02.30", istrue: false },
  { time: "03.00", istrue: true },
  { time: "04.00", istrue: true },
  { time: "05.30", istrue: false }
];


export function antiShake(fn, delay) {
  // 如果没传延迟时间，就默认200毫秒
  var delay = delay || 200
 
  // 记录上一次触发的定时器
  var timer = null
  return function () {
    const th = this
    var args = arguments
    // 如果定时器还没结束，再次触发了这个函数
    // 就清除这个定时器，重新计时
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      // 定时器结束，正常执行函数
      fn.apply(th, args)
    }, delay)}}

/**
 * @param {Function} fun 需要限制执行频率的函数
 * @param {Number} delay 延迟时间，这段时间过后，才可触发第二次
 */
export function Debounce  (fun, delay) {
  // 记录上一次触发的时间
  var timer = null;
  var debounced = function () {
    var ctx = this;
    var args = arguments;
    // 清除上一次延时器
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      fun.apply(ctx, args);
    }, delay);
  };
  return debounced;
}